import React from "react";
import { CURRENCY_CODE_LIST } from "../../config/constants";
import { useUserPreferences } from "../../hooks/useUserPreferences";

const PriceInput = React.forwardRef(({ optional, ...props }, ref) => {
  const { currency: userCurrency } = useUserPreferences();
  const currency = props.currency ? props.currency : userCurrency;

  return (
    <div>
      <label
        htmlFor={props.id ?? props.name ?? "price"}
        className="block text-sm/6 font-medium text-ink-700"
      >
        {props.label}
        {optional && (
          <span className="ml-1 font-normal text-ink-400">(optional)</span>
        )}
      </label>
      <div className="mt-2">
        <div className="flex items-center rounded-card bg-white px-3 border border-ink-200 focus-within:border-accent-500 focus-within:ring-2 focus-within:ring-accent-500/20 transition-colors">
          <div className="shrink-0 select-none text-base text-ink-500 sm:text-sm/6">
            {CURRENCY_CODE_LIST.find((code) => code.id === currency)?.symbol ||
              "$"}
          </div>
          <input
            ref={ref}
            {...props}
            placeholder="0.00"
            aria-describedby="price-currency"
            className="block min-w-0 grow border-0 bg-transparent py-2 pl-1 pr-3 text-base text-ink-900 placeholder:text-ink-400 focus:outline-none focus:ring-0 sm:text-sm/6 appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]"
          />
          <div
            id="price-currency"
            className="shrink-0 select-none text-base text-ink-500 sm:text-sm/6"
          >
            {currency}
          </div>
        </div>
      </div>
      {props.errormessage ? (
        <div className="mt-2 text-sm text-signal-red-700">
          <p>{props.errormessage}</p>
        </div>
      ) : null}
    </div>
  );
});

export default PriceInput;
